var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "my-info" }, [
        _c("div", { staticClass: "info-block my-base-info" }, [
          _c("div", { staticClass: "x-row" }, [
            _c("div", { staticClass: "x-col-8" }, [
              _c(
                "div",
                {
                  staticClass: "info-avatar",
                  on: { click: _vm.changeMyAvatar }
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.userInfo.avatarUrl
                        ? _vm.userInfo.avatarUrl
                        : _vm.img.myDatum
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "my-info-name color-dark" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.userInfo.realName) +
                    "\n                    "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "x-col-4" }, [
              _c(
                "div",
                { staticClass: "my-info-setting color-default text-right" },
                [
                  _c("span", { on: { click: _vm.goSettingPage } }, [
                    _vm._v("个人设置")
                  ]),
                  _vm._v(" "),
                  _c("span", { on: { click: _vm.goTeachPage } }, [
                    _vm._v("教师中心")
                  ])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.studentDataApprovalDesc
          ? _c("div", { staticClass: "notice-message" }, [
              _vm._v(_vm._s(_vm.studentDataApprovalDesc))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "info-block my-task" }, [
          _c("div", { staticClass: "info-title" }, [_vm._v("我的任务")]),
          _vm._v(" "),
          _c("div", { staticClass: "my-task-list" }, [
            _c(
              "div",
              {
                staticClass: "my-task-item",
                on: {
                  click: function($event) {
                    _vm.taskInfo.course.canClick && _vm.chooseMyCourse()
                  }
                }
              },
              [
                _c("div", { staticClass: "img" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.taskInfo.course.active
                        ? _vm.img.task
                        : _vm.img.undoTask
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text color-default" }, [
                  _vm._v("选择课程")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "my-task-item",
                on: {
                  click: function($event) {
                    _vm.taskInfo.completeInfo.canClick && _vm.completeInfo()
                  }
                }
              },
              [
                _c("div", { staticClass: "img" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.taskInfo.completeInfo.active
                        ? _vm.img.task
                        : _vm.img.undoTask
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text color-default" }, [
                  _vm._v("完善资料")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "my-task-item",
                on: {
                  click: function($event) {
                    _vm.taskInfo.exam.canClick && _vm.startExam()
                  }
                }
              },
              [
                _c("div", { staticClass: "img" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.taskInfo.exam.active
                        ? _vm.img.task
                        : _vm.img.undoTask
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text color-default" }, [
                  _vm._v("在线考试")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "my-task-list" }, [
            _c(
              "div",
              {
                staticClass: "my-task-item",
                on: {
                  click: function($event) {
                    _vm.taskInfo.school.canClick && _vm.chooseSchool()
                  }
                }
              },
              [
                _c("div", { staticClass: "img" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.taskInfo.school.active
                        ? _vm.img.task
                        : _vm.img.undoTask
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text color-default" }, [
                  _vm._v("选择学校")
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "my-task-item" }, [
              _c("div", { staticClass: "img" }, [
                _c("img", {
                  attrs: {
                    src: _vm.taskInfo.exercise.active
                      ? _vm.img.task
                      : _vm.img.undoTask
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text color-default" }, [
                _vm._v("实操培训")
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "my-task-item",
                on: {
                  click: function($event) {
                    _vm.taskInfo.returnVisit.canClick && _vm.returnVisit()
                  }
                }
              },
              [
                _c("div", { staticClass: "img" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.taskInfo.returnVisit.active
                        ? _vm.img.task
                        : _vm.img.undoTask
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text color-default" }, [
                  _vm._v("满意度调查")
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { float: "right", "margin-right": "5px" } },
          [
            _vm.studyAgainFlag
              ? _c(
                  "mt-button",
                  {
                    staticStyle: { "font-size": "12px" },
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.studentProgressOver }
                  },
                  [_vm._v("\n                再学一门\n            ")]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        !_vm.myCourse2
          ? _c("div", { staticClass: "info-block my-course" }, [
              _c(
                "div",
                {
                  staticClass: "info-title text color-default",
                  staticStyle: { "text-align": "right", color: "#2766ff" },
                  on: {
                    click: function($event) {
                      return _vm.courseListInfo()
                    }
                  }
                },
                [_vm._v("更多选课信息")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "info-title" }, [_vm._v("我的必修课")]),
              _vm._v(" "),
              !_vm.taskInfo.course || !_vm.myCourse
                ? _c(
                    "div",
                    {
                      staticClass: "my-img-button",
                      on: { click: _vm.chooseMyCourse }
                    },
                    [
                      _c("div", { staticClass: "img" }, [
                        _c("img", { attrs: { src: _vm.img.myCourse } })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text color-default" }, [
                        _vm._v("选择我的必修课")
                      ])
                    ]
                  )
                : _c("div", { staticClass: "common-info text-left" }, [
                    _c("table", [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "common-cover",
                            attrs: { rowspan: "4" }
                          },
                          [_c("img", { attrs: { src: _vm.myCourse.coverurl } })]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "common-title color-dark",
                            attrs: { colspan: "2" }
                          },
                          [_vm._v(_vm._s(_vm.myCourse.title))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "common-content color-dark-gray",
                            attrs: { colspan: "2" }
                          },
                          [
                            !!_vm.myCourse.contentsummary
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "clampy",
                                        rawName: "v-clampy",
                                        value: 4,
                                        expression: "4"
                                      }
                                    ],
                                    class: {
                                      "display-hide": !!_vm.courseDisplayInfo[
                                        "1"
                                      ]
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleDisplay(
                                          _vm.courseDisplayInfo,
                                          "1"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.myCourse.contentsummary) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class: {
                                  "display-hide": !_vm.courseDisplayInfo["1"]
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleDisplay(
                                      _vm.courseDisplayInfo,
                                      "1"
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.myCourse.contentsummary) +
                                    "\n                            "
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticClass: "text" }),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "common-button rgy" },
                          [
                            _c(
                              "mt-button",
                              {
                                staticClass: "bg-orange",
                                staticStyle: { "font-size": "13px" },
                                attrs: { size: "small", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.goCourseInfoPage(
                                      _vm.myCourse.courseid,
                                      _vm.myCourse.stage
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.myCourse.stagetxt || "开始学习"
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.myCourse
          ? _c("div", { staticClass: "info-block my-course" }, [
              _c(
                "div",
                {
                  staticClass: "info-title text color-default",
                  staticStyle: { "text-align": "right", color: "#2766ff" },
                  on: {
                    click: function($event) {
                      return _vm.courseListInfo()
                    }
                  }
                },
                [_vm._v("更多选课信息")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "info-title" }, [
                _vm._v("我的岗前培训课")
              ]),
              _vm._v(" "),
              !_vm.myCourse2
                ? _c(
                    "div",
                    {
                      staticClass: "my-img-button",
                      on: { click: _vm.chooseMyCourse }
                    },
                    [
                      _c("div", { staticClass: "img" }, [
                        _c("img", { attrs: { src: _vm.img.myCourse } })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text color-default" }, [
                        _vm._v("选择我的岗前培训课")
                      ])
                    ]
                  )
                : _c("div", { staticClass: "common-info text-left" }, [
                    _c("table", [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "common-cover",
                            attrs: { rowspan: "4" }
                          },
                          [
                            _c("img", {
                              attrs: { src: _vm.myCourse2.coverurl }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "common-title color-dark",
                            attrs: { colspan: "2" }
                          },
                          [_vm._v(_vm._s(_vm.myCourse2.title))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "common-content color-dark-gray",
                            attrs: { colspan: "2" }
                          },
                          [
                            !!_vm.myCourse2.contentsummary
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "clampy",
                                        rawName: "v-clampy",
                                        value: 4,
                                        expression: "4"
                                      }
                                    ],
                                    class: {
                                      "display-hide": !!_vm.courseDisplayInfo[
                                        "2"
                                      ]
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleDisplay(
                                          _vm.courseDisplayInfo,
                                          "2"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.myCourse2.contentsummary) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class: {
                                  "display-hide": !_vm.courseDisplayInfo["2"]
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleDisplay(
                                      _vm.courseDisplayInfo,
                                      "2"
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.myCourse2.contentsummary) +
                                    "\n                            "
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticClass: "text" }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.myCourse2.teacher,
                                  expression: "myCourse2.teacher"
                                }
                              ]
                            },
                            [_vm._v("主讲人:" + _vm._s(_vm.myCourse2.teacher))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.myCourse2.duration,
                                  expression: "myCourse2.duration"
                                }
                              ]
                            },
                            [_vm._v(_vm._s(_vm.myCourse2.duration) + "课时")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "common-button" },
                          [
                            _c(
                              "mt-button",
                              {
                                staticClass: "bg-orange",
                                staticStyle: { "font-size": "13px" },
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.goCourseInfoPage(
                                      _vm.myCourse2.courseid,
                                      _vm.myCourse2.stage,
                                      true
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm._f("stageText")(
                                        _vm.myCourse2.stage,
                                        _vm.myCourse2.stagetxt
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "info-block my-datum" }, [
          _c("div", { staticClass: "info-title" }, [_vm._v("完善资料")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "my-img-button",
              on: {
                click: function($event) {
                  return _vm.completeInfo()
                }
              }
            },
            [
              _c("div", { staticClass: "img" }, [
                _c("img", { attrs: { src: _vm.img.myDatum } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text color-default" }, [
                _vm._v("完善我的资料")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-block my-school" }, [
          _c("div", { staticClass: "info-title" }, [_vm._v("选择学校")]),
          _vm._v(" "),
          !_vm.mySchool || !_vm.mySchool.schoolid
            ? _c(
                "div",
                {
                  staticClass: "my-img-button",
                  on: {
                    click: function($event) {
                      return _vm.chooseSchool()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "img" }, [
                    _c("img", { attrs: { src: _vm.img.mySchool } })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text color-default" }, [
                    _vm._v("选择我的学校")
                  ])
                ]
              )
            : _c("div", { staticClass: "common-info text-left" }, [
                _c("table", [
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "common-cover", attrs: { rowspan: "2" } },
                      [
                        _c("img", {
                          attrs: { src: _vm.mySchool.introimageurl }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "common-title color-dark" }, [
                      _vm._v(_vm._s(_vm.mySchool.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "common-content color-dark-gray" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm._f("emptyText")(
                                _vm.mySchool.contact,
                                "联系人："
                              )
                            )
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm._f("emptyText")(
                                _vm.mySchool.contactno,
                                "联系固话："
                              )
                            )
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm._f("emptyText")(
                                _vm.mySchool.contactmobile,
                                "联系手机："
                              )
                            ) +
                            "\n                        "
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { height: "40px" } },
                  [
                    _c(
                      "mt-button",
                      {
                        staticClass: "bg-orange",
                        staticStyle: { "font-size": "12px", float: "right" },
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.changeSchool }
                      },
                      [
                        _vm._v(
                          "\n                        更换学校\n                    "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { height: "40px" } },
                  [
                    _c(
                      "mt-button",
                      {
                        staticClass: "bg-orange",
                        staticStyle: { "font-size": "12px", float: "right" },
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.joinClass }
                      },
                      [
                        _vm._v(
                          "\n                        扫码加入班级\n                    "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-block my-school" }, [
          _c("div", { staticClass: "info-title" }, [_vm._v("考勤打卡")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "my-img-button",
              on: {
                click: function($event) {
                  return _vm.punchCards()
                }
              }
            },
            [
              _c("div", { staticClass: "img" }, [
                _c("img", { attrs: { src: _vm.img.mySignin } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text color-default" }, [
                _vm._v("考勤打卡")
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("footer-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd299e44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd299e44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/personal/personal.vue
// module id = null
// module chunks = 